import { Tag } from 'antd';
import {
  DIRECTION_LABELS,
  STATUS_LABELS,
  DELIVERY_STATUS_LABELS,
} from '../../../../services/tradeCommitmentService';

const statusColor = { ACTIVE: 'blue', CONVERTED: 'green', CANCELLED: 'default' };
const directionColor = { SELL: 'purple', BUY: 'cyan' };

export function getTradeCommitmentColumns() {
  return [
    {
      title: 'Ref',
      dataIndex: 'ref',
      key: 'ref',
      render: (v, row) => v || `TC-${row.numeric_id}`,
    },
    {
      title: 'Direction',
      dataIndex: 'direction',
      key: 'direction',
      render: (v) => <Tag color={directionColor[v]}>{DIRECTION_LABELS[v] || v}</Tag>,
    },
    {
      title: 'Product',
      dataIndex: 'product_short_name',
      key: 'product',
      render: (v, row) => v || row.product_name,
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Price',
      dataIndex: 'price_per_share',
      key: 'price_per_share',
    },
    {
      title: 'Counterparty',
      dataIndex: 'counterparty_name',
      key: 'counterparty_name',
    },
    {
      title: 'Expected',
      dataIndex: 'expected_amount',
      key: 'expected_amount',
      render: (v) => formatMoney(v),
    },
    {
      title: 'Delivery',
      dataIndex: 'delivery_status',
      key: 'delivery_status',
      render: (v) => DELIVERY_STATUS_LABELS[v] || v,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (v) => <Tag color={statusColor[v]}>{STATUS_LABELS[v] || v}</Tag>,
    },
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source',
    },
  ];
}

export const apiErrMsg = (err) => err?.message || 'Something went wrong';

export const formatMoney = (n) =>
  n != null
    ? Number(n).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 })
    : '—';
